export default __webpack_public_path__ + "static/media/room-1336497_640.4fdc41c7.jpg";